import { Route } from '@angular/router';
import { SOFTLINE_ROUTE_DATA_MODULE } from '@softline/application';
import {
  SOFTLINE_CONST_LAGER_ABC_ANALYSIS_MODULE_HEADER,
  SOFTLINE_PERMISSION_ABC_ANALYSIS,
} from './abc-analysis.shared';
import { configurationGuard } from './guards/configuration.guard';
import { AbcAnalysisRepository } from './repositories/abc-analysis.repository';
import { AbcAnalysisService } from './services/abc-analysis.service';

export const abcAnalysisRoutes: Route[] = [
  {
    path: 'abc-analysis',
    providers: [AbcAnalysisService, AbcAnalysisRepository],
    data: {
      permission: SOFTLINE_PERMISSION_ABC_ANALYSIS,
      [SOFTLINE_ROUTE_DATA_MODULE]: SOFTLINE_CONST_LAGER_ABC_ANALYSIS_MODULE_HEADER,
    },
    children: [
      {
        path: 'configuration',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/configuration/configuration.component').then(
            (m) => m.ConfigurationComponent
          ),
      },
      {
        path: 'storage-selection',
        pathMatch: 'full',
        canActivate: [configurationGuard],
        loadComponent: () =>
          import('./pages/storage-selection/storage-selection.component').then(
            (m) => m.StorageSelectionComponent
          ),
      },
      {
        path: ':storageId',
        canActivate: [configurationGuard],
        loadComponent: () =>
          import('./pages/category-selection/category-selection.component').then(
            (m) => m.CategorySelectionComponent
          ),
      },
      {
        path: ':storageId/:categoryLetter',
        canActivate: [configurationGuard],
        loadComponent: () =>
          import('./pages/category-detail/category-detail.component').then(
            (m) => m.CategoryDetailComponent
          ),
      },
      {
        path: '**',
        redirectTo: '/abc-analysis/storage-selection',
      },
    ],
  },
];
